import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import { AuthContext } from '../libs/contexts/authContext'
import {
  Box,
  Button,
  Grid,
  Paper,
  Rating,
  Slider,
  Snackbar,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  TextField,
  Select,
  MenuItem,
} from '@mui/material'
import React, { useState, useEffect, useContext } from 'react'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import { useNavigate } from 'react-router-dom'
import FilterButton from './FilterButton'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'

function Dashboard({ ...props }) {
  const [rating, setRating] = useState(4.2)
  const [sliderValue, setSliderValue] = useState(30)
  const [timeframe, setTimeframe] = useState('year')
  const [timeframeData, setTimeframeData] = useState(props.yearlyData)
  const [openCasesObj, setOpenCasesObj] = useState(props.openCases[0])
  const [distributor, setDistributor] = useState('1')
  const [agency, setAgency] = useState('1')
  const [product, setProduct] = useState('1')
  const { affiliateCode } = useContext(AuthContext)
  const [agentList, setAgentList] = useState([])
  const navigate = useNavigate()
  const [agencyList, setAgencyList] = useState([])
  const [productList, setProductList] = useState([])
  const [distributorList, setDistributorList] = useState([])

  const handleTimeframeToggle = (event, newTimeframe) => {
    if (newTimeframe != null) {
      setTimeframe(newTimeframe)
    }
  }

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue)
  }

  const decrementSlider = (event) => {
    setSliderValue(sliderValue - 1)
  }

  const incrementSlider = (event) => {
    setSliderValue(sliderValue + 1)
  }

  const handleDistributorFilterChange = (event) => {
    setDistributor(event.target.value)
    setAgency('1')
  }

  const handleProductFilterChange = (event) => {
    setProduct(event.target.value)
  }

  const handleAgencyFilterChange = (event) => {
    setAgency(event.target.value)
    setProduct('1')
  }

  const handleAgentsSearch = (event, value) => {
    if (value != null) {
      setProduct('1')
      const data = {
        affiliateCode: value.affCode,
      }
      props.getAggregatedData(data)
      props.getOpenCases(data)
    }
  }

  useEffect(() => {
    setAgencyList(props.agencyList)
    setProductList(props.productList)
    setDistributorList(props.distributorList)
  }, [props.agencyList, props.productList, props.distributorList])

  useEffect(() => {
    if (props.relationalType === 97) {
      setAgency(props?.userSourceCode)
    } else if (props.relationalType === 107) {
      setDistributor(props?.userSourceCode)
    }
  }, [])

  useEffect(() => {
    let data = {}
    if (props.relationalType === 97) {
      data = {
        agencyId: agency.toString(),
        productId: product.toString(),
      }
    } else {
      data = {
        distributorId: distributor.toString(),
        agencyId: agency.toString(),
        productId: product.toString(),
      }
    }
    const agentData = {
      distributorId: '8973',
      agencyId: '1',
    }
    props.getAggregatedDataDistributor(data)
    props.getOpenCasesDistributor(data)
    props.getAgentList(agentData)
  }, [agency, product, distributor])

  useEffect(() => {
    let data = {
      agencyId: agency.toString(),
    }
    props.getAgencyProductListPersona(data)
  }, [agency])

  useEffect(() => {
    let data = {
      distributorId: distributor.toString(),
    }
    props.getAgencyProductListPersona(data)
  }, [distributor])

  useEffect(() => {
    const data = {
      affiliateCode,
    }
    let upData = {}
    let listData = {}
    if (props.relationalType === 97) {
      upData = {
        agencyId: props?.userSourceCode?.toString(),
        productId: '1',
      }
      listData = {
        agencyId: props?.userSourceCode?.toString(),
        initialization: true,
      }
    } else if (props.relationalType === 107) {
      upData = {
        distributorId: props?.userSourceCode?.toString(),
        agencyId: '1',
        productId: '1',
      }
      listData = {
        distributorId: props?.userSourceCode?.toString(),
        initialization: true,
      }
    } else if (props.relationalType === 117) {
      upData = {
        distributorId: '1',
        agencyId: '1',
        productId: '1',
      }
      listData = {
        afficiencyPersona: true,
      }
    }
    const dashboardCalls = async () => {
      if (props.relationalType != 87) {
        await props.getAggregatedDataDistributor(upData)
        await props.getOpenCasesDistributor(upData)
        await props.getAgencyProductListPersona(listData)
      } else {
        await props.getAggregatedData(data)
        await props.getOpenCases(data)
      }
      props.getNotifications({})
    }
    dashboardCalls()
  }, [])

  useEffect(() => {
    let agentNamesAff = []
    if(props.agentList?.length >= 1){
    agentNamesAff = props.agentList?.map((agent) => ({
      label: `${agent.name}`,
      affCode: `${agent.affilateCode}`,
    }))}
    setAgentList(agentNamesAff)
  }, [props.agentList])

  useEffect(() => {
    if (timeframe === 'year') {
      setTimeframeData(props.yearlyData)
    } else if (timeframe === 'quarter') {
      setTimeframeData(props.quarterlyData)
    } else if (timeframe === 'month') {
      setTimeframeData(props.monthlyData)
    } else {
      setTimeframeData(props.weeklyData)
    }
  }, [props.yearlyData, timeframe])

  useEffect(() => {
    if (props.openCases?.length > 1) {
      setOpenCasesObj(props.openCases.find((item) => item.expiration_days == sliderValue))
    }
  }, [props.openCases, sliderValue])

  const handleScorecardView = (e) => {
    e.preventDefault()
    navigate(`/scorecard?affiliateCode=${affiliateCode}&userSourceCode=8973`)
  }

  const filterOptions = createFilterOptions({
    limit: 150,
  })
  return (
    <div
      style={{
        backgroundColor: 'rgba(241, 243, 246, 1)',
        fontFamily: 'Roboto',
        minHeight: '100vh',
        paddingTop: '25px',
      }}
    >
      <Box sx={{ marginTop: 6 }}>
        <Grid container spacing={3} padding="12px" height="100%">
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Box sx={dashboardStyle.notificationBanner}>
              <InfoIcon sx={{ marginX: '5px', color: 'white' }} />
              <Typography color="white" marginX="5px">
                {props.notificationMessage?.[0]?.message ?? 'Loading messages'}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={12}>
            <Typography align="left" variant="h1" style={{ padding: '24px 6px', fontSize: '24px' }}>
              Dashboard
            </Typography>
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: { lg: 'end', md: 'end', sm: 'end', xs: 'center' },
              alignItems: 'center',
            }}
          >
            {' '}
            {props.relationalType !== 87 && (
              <Grid container spacing={1}>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  {props.relationalType !== 97 && (
                    <TextField
                      select
                      label="Distributor"
                      name="distributor"
                      sx={dashboardStyle.textField}
                      size="small"
                      value={distributor}
                      onChange={handleDistributorFilterChange}
                      disabled={props.relationalType === 107}
                    >
                      {distributorList?.map((dist) => (
                        <MenuItem key={dist.distributor_name} value={dist.distributor_id}>
                          {dist.distributor_name}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <TextField
                    select
                    label="Agency"
                    name="agency"
                    sx={dashboardStyle.textField}
                    size="small"
                    value={agency}
                    onChange={handleAgencyFilterChange}
                    disabled={props.relationalType === 97}
                  >
                    {agencyList?.map((agency) => (
                      <MenuItem key={agency.agency_name} value={agency.agency_id}>
                        {agency.agency_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={agentList}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option.affCode}>
                          {option.label}
                        </li>
                      )
                    }}
                    sx={{ paddingBottom: '5px' }}
                    onChange={handleAgentsSearch}
                    filterOptions={filterOptions}
                    renderInput={(params) => (
                      <TextField {...params} sx={dashboardStyle.textField} size="small" label="Agents" />
                    )}
                  />
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <TextField
                    select
                    label="Product"
                    name="product"
                    sx={dashboardStyle.textField}
                    size="small"
                    value={product}
                    onChange={handleProductFilterChange}
                  >
                    {productList?.map((product) => (
                      <MenuItem key={product.product_name} value={product.product_id}>
                        {product.product_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            )}
            <ToggleButtonGroup
              color="primary"
              value={timeframe}
              exclusive
              onChange={handleTimeframeToggle}
              size="large"
              sx={{ height: '25px' }}
            >
              <ToggleButton value="week">W</ToggleButton>
              <ToggleButton value="month">M</ToggleButton>
              <ToggleButton value="quarter">Q</ToggleButton>
              <ToggleButton value="year">Y</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Typography align="left" fontSize={'12px'} marginX="30px">
            Data displayed is current as of previous day.
          </Typography>
          <Grid item lg={12} sm={12} xs={12}>
            <Paper sx={{ padding: '16px' }}>
              <Grid container spacing={4}>
                <Grid item lg={5} md={5} sm={5} xs={12}>
                  <Box sx={dashboardStyle.statsBox1}>
                    <Typography fontSize={'14px'}>QUALITY OF BUSINESS SCORE</Typography>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Rating
                        name="half-rating-read"
                        value={props.qualityScore}
                        precision={0.1}
                        sx={{
                          '& .MuiRating-iconFilled': { color: '#3C4FB9' },
                          marginX: '8px',
                        }}
                        max={10}
                        readOnly
                      />
                      <Typography color={'#3C4FB9'}>{props.qualityScore}</Typography>
                    </div>
                  </Box>
                </Grid>
                {props.relationalType !== 87 ? (
                  <Grid item lg={3} md={3} sm={3} xs={12}>
                    <Box sx={dashboardStyle.statsBox1}>
                      <Typography color={'#263497'} fontFamily={'Roboto Slab'} fontSize={'30px'}>
                        {props?.totalNumAgencies}
                      </Typography>
                      <Typography marginX={'6px'} fontSize={'12px'}>
                        {props?.totalNumAgencies == 1 ? 'Agency' : 'Agencies'}
                      </Typography>
                    </Box>
                  </Grid>
                ) : (
                  <Grid item lg={2} md={2} sm={2} xs={12}>
                    <Box sx={dashboardStyle.statsBox1}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography color={'#263497'} fontFamily={'Roboto Slab'} fontSize={'30px'}>
                          {props.totalNumAgencies != null ? props.totalNumAgencies : '-'}
                        </Typography>
                        {/* <sup style={{ color: "#263497" }}>rd</sup> */}
                      </div>
                      <Typography marginX={'6px'} fontSize={'12px'}>
                        of 4973 agents
                      </Typography>
                    </Box>
                  </Grid>
                )}
                {props.relationalType !== 87 ? (
                  <Grid item lg={2} md={2} sm={2} xs={12}>
                    <Box sx={dashboardStyle.statsBox1}>
                      <Typography color={'#263497'} fontFamily={'Roboto Slab'} fontSize={'30px'}>
                        {props.totalNumAgents != null ? props.totalNumAgents : '-'}
                      </Typography>
                      <Typography marginX={'6px'} fontSize={'12px'}>
                        Agents
                      </Typography>
                    </Box>
                  </Grid>
                ) : (
                  <Grid item lg={3} md={3} sm={3} xs={12}>
                    <Box sx={dashboardStyle.statsBox1}>
                      <Typography color={'#263497'} fontFamily={'Roboto Slab'} fontSize={'30px'}>
                        {props.iaiRate != null ? props.iaiRate : '-'}
                      </Typography>
                      <Typography marginX={'6px'} fontSize={'12px'}>
                        Excessive Application Activity
                      </Typography>
                    </Box>
                  </Grid>
                )}

                <Grid item lg={2} md={2} sm={2} xs={12}>
                  <Button sx={dashboardStyle.detailButton} onClick={(e) => handleScorecardView(e)}>
                    View Details
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item lg={12} sm={12} xs={12}>
            <Paper sx={{ padding: '32px' }}>
              <Grid container spacing={2} height="100%">
                <Grid item lg={2} md={12} sm={12} xs={12}>
                  <Typography color="#64768C" align="left">
                    OPEN CASES
                  </Typography>
                </Grid>
                <Grid item lg={10} md={12} sm={12} xs={12}>
                  <Typography align="left" fontSize={'12px'} color="#252D36">
                    Case age (in days):
                  </Typography>
                  <Box display="flex" flexDirection="row">
                    <Button sx={dashboardStyle.sliderButton} onClick={decrementSlider}>
                      <RemoveCircleIcon fontSize="large" color="black" />
                    </Button>
                    <Slider
                      min={1}
                      max={60}
                      value={sliderValue}
                      onChange={handleSliderChange}
                      valueLabelDisplay="on"
                      valueLabelFormat={(value) => (value === 1 ? <p>{value} day</p> : <p>{value} days</p>)}
                    ></Slider>
                    <Button sx={dashboardStyle.sliderButton} onClick={incrementSlider}>
                      <AddCircleIcon fontSize="large" />
                    </Button>
                  </Box>
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <div style={dashboardStyle.statsBox2}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {openCasesObj?.approved_incomplete_apps_count != null
                        ? openCasesObj.approved_incomplete_apps_count
                        : '-'}
                    </Typography>
                    <Typography sx={dashboardStyle.statsCaptions}>Approved Incomplete Apps</Typography>
                  </div>
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <div style={dashboardStyle.statsBox2}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {openCasesObj?.paid_not_signed_count != null ? openCasesObj.paid_not_signed_count : '-'}
                    </Typography>
                    <Typography sx={dashboardStyle.statsCaptions}>Paid not Signed</Typography>
                  </div>
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <div style={dashboardStyle.statsBox2}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {openCasesObj?.missing_first_payment_count != null
                        ? openCasesObj.missing_first_payment_count
                        : '-'}
                    </Typography>
                    <Typography sx={dashboardStyle.statsCaptions}>Missing First Payment</Typography>
                  </div>
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <div style={dashboardStyle.statsBox2}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {openCasesObj?.risk_of_lapse_flag != null ? openCasesObj.risk_of_lapse_flag : '-'}
                    </Typography>
                    <Typography sx={dashboardStyle.statsCaptions}>Risk of Lapse</Typography>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <Paper sx={{ padding: '32px' }}>
              <Grid container spacing={2} height="100%">
                <Grid item lg={7} md={6} sm={6} xs={6} display="flex" alignItems="center" justifyContent="start">
                  <Typography color="#64768C" fontSize={'14px'}>
                    PRODUCT & APPOINTMENT STATUS
                  </Typography>
                </Grid>
                <Grid item lg={5} md={6} sm={6} xs={6} display="flex" alignItems="center" justifyContent="end">
                  <Button sx={dashboardStyle.detailButton} disabled>
                    License Status
                  </Button>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4}>
                  <div style={dashboardStyle.statsBox3}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {props.productLibrary}
                    </Typography>
                    <Typography sx={dashboardStyle.statsCaptions}>Product Library</Typography>
                  </div>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4}>
                  <div style={dashboardStyle.statsBox3}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {props.productEligible}
                    </Typography>
                    <Typography sx={dashboardStyle.statsCaptions}>Product Eligible</Typography>
                  </div>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4}>
                  <div style={dashboardStyle.statsBox3}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {props.productAccess}
                    </Typography>
                    <Typography sx={dashboardStyle.statsCaptions}>Product Access</Typography>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <Paper sx={{ padding: '32px' }}>
              <Grid container spacing={2} height="100%">
                <Grid item lg={7} md={6} sm={6} xs={6} display="flex" alignItems="center" justifyContent="start">
                  <Typography color="#64768C" fontSize="14px">
                    CUSTOMER SUPPORT TICKETS
                  </Typography>
                </Grid>
                <Grid item lg={5} md={6} sm={6} xs={6} display="flex" alignItems="center" justifyContent="end">
                  <Button sx={dashboardStyle.detailButton} disabled>
                    View Details
                  </Button>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4}>
                  <div style={dashboardStyle.statsBox3}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {timeframeData?.ticketsOpened ? timeframeData.ticketsOpened : '-'}
                    </Typography>
                    <Typography sx={dashboardStyle.statsCaptions}>Opened</Typography>
                  </div>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4}>
                  <div style={dashboardStyle.statsBox3}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {timeframeData?.ticketsInProgress ? timeframeData.ticketsInProgress : '-'}
                    </Typography>
                    <Typography sx={dashboardStyle?.statsCaptions}>In Progress</Typography>
                  </div>
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4}>
                  <div style={dashboardStyle.statsBox3}>
                    <Typography margin="16px" sx={dashboardStyle.statsNumber}>
                      {timeframeData?.ticketsClosed ? timeframeData.ticketsClosed : '-'}
                    </Typography>
                    <Typography sx={dashboardStyle?.statsCaptions}>Closed</Typography>
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item lg={12} sm={12} xs={12}>
            <Grid container spacing={2} height="100%">
              <Grid item lg={6} sm={6} xs={6} display="flex" alignItems="center" justifyContent="start">
                <Typography fontSize={'20px'}>Applications</Typography>
              </Grid>
              <Grid item lg={6} sm={6} xs={6} display="flex" alignItems="center" justifyContent="end">
                <Button
                  sx={dashboardStyle?.newAppButton}
                  onClick={() =>
                    window.open(
                      'https://lifeeapp-agent-live.afficiency.com/?productId=8118&distributorId=8973&affiliateCode=NPN19947866',
                      '_blank'
                    )
                  }
                  disabled={props.relationalType !== 87}
                >
                  + New Application
                </Button>
              </Grid>
              <Grid item lg={3} md={3} sm={3} xs={6}>
                <Box style={dashboardStyle.statsBox1} padding="4px">
                  <Typography color={'#263497'} fontFamily={'Roboto Slab'} fontSize={'30px'}>
                    {timeframeData?.approvalRate ? (timeframeData.approvalRate * 100).toFixed() : '-'}%
                  </Typography>
                  <Typography marginX={'6px'} fontSize={'12px'}>
                    Approval Rate
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={3} md={3} sm={3} xs={6}>
                <Box style={dashboardStyle.statsBox1} padding="4px">
                  <Typography color={'#263497'} fontFamily={'Roboto Slab'} fontSize={'30px'}>
                    {timeframeData?.declineRate ? (timeframeData.declineRate * 100).toFixed() : '-'}%
                  </Typography>
                  <Typography marginX={'6px'} fontSize={'12px'}>
                    Non-Insurable Declines
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={3} md={3} sm={3} xs={6}>
                <Box style={dashboardStyle.statsBox1} padding="4px">
                  <Typography color={'#263497'} fontFamily={'Roboto Slab'} fontSize={'30px'}>
                    {timeframeData?.conversionRate ? (timeframeData.conversionRate * 100).toFixed() : '-'}%
                  </Typography>
                  <Typography marginX={'6px'} fontSize={'12px'}>
                    Conversion Rate
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={3} md={3} sm={3} xs={6}>
                <Box style={dashboardStyle.statsBox1} padding="4px">
                  <Typography color={'#263497'} fontFamily={'Roboto Slab'} fontSize={'30px'}>
                    {timeframeData?.policyIssuedRate ? (timeframeData.policyIssuedRate * 100).toFixed() : '-'}%
                  </Typography>
                  <Typography marginX={'6px'} fontSize={'12px'}>
                    Policy Issued Rate
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

export default Dashboard

const dashboardStyle = {
  containerBox: {
    backgroundColor: 'rgba(241, 243, 246, 1)',
    fontFamily: 'Roboto',
    width: '100vw',
    padding: '16px 32px',
    display: 'flex',
    flexDirection: 'column',
    margin: '0px auto',
  },

  notificationBanner: {
    backgroundColor: '#5968C3',
    padding: '12px 16px 12px 16px',
    display: 'flex',
    alignItems: 'start',
    borderRadius: '8px',
  },

  statsBox1: {
    border: '1px solid rgba(196, 202, 241, 1)',
    borderRadius: '8px',
    color: 'rgba(100, 118, 140, 1)',
    height: '100%',
    display: 'flex',
    flexDirection: { lg: 'row', md: 'column', sm: 'column', xs: 'column' },
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
  },

  statsBox2: {
    backgroundColor: '#F5F7FF',
    color: 'rgba(100, 118, 140, 1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '9px 21px',
    borderRadius: '8px',
    height: '95%',
  },

  statsBox3: {
    color: 'rgba(100, 118, 140, 1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '9px 14px',
    borderRadius: '8px',
    height: '95%',
  },

  statsNumber: {
    color: '#3C4FB9',
    fontWeight: '500',
    fontSize: '36px',
    fontFamily: 'Roboto Slab',
  },

  detailButton: {
    textTransform: 'none',
    width: { lg: '70%', md: '65%', sm: '75%', xs: '95%' },
    backgroundColor: 'white',
    color: 'rgba(60, 79, 185, 1)',
    border: '1px solid rgba(60, 79, 185, 1)',
    borderRadius: '100px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
  },

  newAppButton: {
    textTransform: 'none',
    width: { lg: '30%', md: '65%', sm: '75%', xs: '90%' },
    height: '40px',
    backgroundColor: '#3C4FB9',
    color: 'white',
    borderRadius: '100px',
    mt: '10px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },

  sliderButton: {
    textTransform: 'none',
    marginX: '10px',
    minHeight: '40px',
    minWidth: '40px',
    color: '#3C4FB9',
  },

  whiteGridContainer: {
    backgroundColor: 'white',
    width: '100%',
    height: '75%',
    borderRadius: '8px',
    padding: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  statsCaptions: {
    fontSize: { lg: '14px', md: '12px', sm: '12px', xs: '12px' },
  },
  textField: {
    textAlign: 'left',
    backgroundColor: 'white',
    width: { lg: '85%', md: '85%', sm: '238px', xs: '238px' },
    margin: '5px',
  },
}
